import { Injectable } from '@angular/core';
import { LoadTarget } from './load-target';

@Injectable()
export class LoadIndicatorService {
  private loadTargets: LoadTarget[];

  constructor() {
    this.loadTargets = [];
  }

  public isLoading(targetId: string = 'global'): boolean {
    let target: LoadTarget = null;
    let existing = this.loadTargets.filter((t) => t.targetId === targetId);

    if (existing.length == 1) {
      target = existing[0];
    } else {
      //throw new Error('load target not found found');
      return false;
    }

    return target.isLoading;
  }

  public loadStart(targetId: string = 'global') {
    let target: LoadTarget = null;
    let existing = this.loadTargets.filter((t) => t.targetId === targetId);

    if (existing.length == 0) {
      target = new LoadTarget(targetId);
      this.loadTargets.push(target);
    } else if (existing.length == 1) {
      target = existing[0];
    } else {
      throw new Error('multiple load targets found');
    }

    target.loadStart();
  }

  public loadComplete(targetId: string = 'global') {
    let target: LoadTarget = null;
    let existing = this.loadTargets.filter((t) => t.targetId === targetId);

    if (existing.length == 1) {
      target = existing[0];
    } else {
      throw new Error('load target not found found');
    }

    target.loadComplete();
  }
}
